import { useState, useEffect } from "react";
import { useLazyFetchHubwiseTransactionExceptionsQuery } from "../../../services/headofficeadmin";

const useHubwiseTransactions = () => {

    const [search, setSearch] = useState(null);

    const [fetchTrigger, { data, isError, error, isFetching }] = useLazyFetchHubwiseTransactionExceptionsQuery();

    const { pagination, results } = data || { results: [], pagination: { totalCount: 100, page: 0, pageSize: 20, totalPages: null } };
    const { totalCount, page, pageSize: limit } = pagination;

    const [isClearing, setIsClearing] = useState(false);

    const clear = async () => {
        if (isFetching)
            return;
        setIsClearing(true);
        await fetchTrigger({ page: 1, limit, search: search })
            .unwrap()
        setIsClearing(false);
    };

    const isRowLoaded = (index) => (index < results.length) || isClearing;

    const loadMore = () => {
        if (page === 0)
            return clear();
        else
            return fetchTrigger({ page: page + 1, limit, search: search  }).unwrap();
    };

    const reload = (e) => {
        e && typeof (e.preventDefault) === 'function' && e.preventDefault();

        clear();
    }

    useEffect(() => {
            clear();
        }, [search]);

    return {
        results: isClearing ? [] : results,
        totalCount,
        isClearing,
        isError,
        error,
        search,
        setSearch,
        isRowLoaded,
        loadMore,
        reload
    };
}

export default useHubwiseTransactions;